import { useMemo } from 'react'
import { TASK_AUDIT_LOG_TYPES } from 'Data/constants.js'
import { getTaskLogTextParts } from 'Data/format.js'

let EXCLUDE_LOGS = [TASK_AUDIT_LOG_TYPES.TASK_COMMENT_ADDED]

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return [
      ...data
        .filter(log => !EXCLUDE_LOGS.includes(log.type))
        .map(({ type, metadata, created_at, id }) => ({
          id,
          metadata,
          type,
          date: created_at, // keep used for sorting.
          textParts: getTaskLogTextParts({
            type,
            metadata,
            created_at,
            actor: `${metadata?.user || 'Support'}`,
          }),
        })),
    ].sort((a, b) => new Date(b.date) - new Date(a.date))
  }, [data])
}
